import { IUserSystemRoleModel } from '../../../../../../../service/systemRole/entity/IUserSystemRoleModel';
import { IUserSystemRoleService } from '../../../../../../../service/systemRole/entity/IUserSystemRoleService';
import { IRowContextMenuUI } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/IRowContextMenuUI';
import { RowContextMenuDomain } from '../../../../../../design/dataTable/parts/rowContextMenu/domain/RowContextMenuDomain';
import { IDataTableDomain } from '../../../../../../design/dataTable/store/IDataTableDomain';
import { IMainLayoutDomainStore } from '../../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { SystemRoleAdminContextMenuUI } from './SystemRoleAdminContextMenuUI';

export class SystemRoleAdminContextMenuDomain extends RowContextMenuDomain<IUserSystemRoleModel> {
  constructor({
    entityService,
    dataTableDomain,
    layoutDomain,
    ui,
  }: {
    entityService: IUserSystemRoleService;
    dataTableDomain: IDataTableDomain<IUserSystemRoleModel, any>;
    layoutDomain: IMainLayoutDomainStore;
    ui?: IRowContextMenuUI<IUserSystemRoleModel> | null;
  }) {
    super(entityService, dataTableDomain, layoutDomain, undefined, ui);
    this.ui = ui || new SystemRoleAdminContextMenuUI(this);
  }
}
